import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {StateCountry} from 'src/app/shared/common-components/common-structure';
import {LoggerService} from '../../shared/common-components/logger.service';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgencyProfileService extends DataService {

  private baseURI = this.apiUri + '/agencyprofile/';
  private observable$: any;
  private _logger: LoggerService;
  private baseURIInactiveTSP = this.apiUri + '/inactivehhgtsp/';

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  getOrganization(orgId: string): Observable<any> {
    this.setUri(this.baseURI + orgId + '/orgId');
    return this.get();
  }

  getAll(): Observable<any> {
    this.setUri(this.baseURI);
    return this.get();
  }

  getEmailCheck(emailcheck: string): Observable<any> {
    console.log('email to be checked ', emailcheck);
    this.setUri(this.baseURI + emailcheck + '/email/');
    console.log(this.baseUri);
    return this.get();
  }

  saveOrganization(organization: any): Observable<any> {
    // this.baseURI = this.apiUri + '/agencyprofile/organizationSave';
    // http://localhost:8380/tmssserver/agencyprofile/organizationSave
    this.setUri(this.apiUri + '/agencyprofile/organizationSave');
    console.log(organization);
    return this.update(organization);
  }

  //http://localhost:4600/tmssserver/api/agencyprofile/organizationDelete/4266/orgId
  deleteOrganization(orgId: string): Observable<any> {
    this.setUri(this.baseURI + 'organizationDelete/' + orgId + '/orgId');
    return this.get();
  }

  getAllStates(stateCountryType): Observable<[StateCountry]> {
    this.setUri(this.baseURI + stateCountryType + 'statecountrytype');
    console.log(this.baseURI + stateCountryType + 'statecountrytype');
    this.observable$ = this.http.get(this.baseURI + stateCountryType + '/statecountrytype').pipe(catchError(this.handleError));
    return this.observable$;
  }

  getCityState(zip: any): Observable<any> {
    console.log('In getting City State');
    this.setUri(this.baseURI + zip + '/zipcode');
    console.log(this.baseURI + zip + '/zipcode');
    return this.http.get(this.baseURI + zip + '/zipcode').pipe(catchError(this.handleError));
  }

  getAllInactiveTSP():Observable<any>{
    this.setUri(this.baseURIInactiveTSP+"getallinactivehhgtsp");
    return this.get();
  }

}
